import { style, styleVariants } from "@vanilla-extract/css";
import { vars } from "plos/src/styles/theme.css";

const FDRCellBaseStyles = style({
  display: "flex",
  flex: 1,
  alignItems: "center",
  justifyContent: "center",
  gap: vars.space["2xs"],
  marginTop: "0.2rem",
  borderRadius: vars.radii.xs,
  padding: "0.2rem",
  width: 100,
  height: 56,
  fontSize: vars.fontSizes.body.m,
  selectors: {
    '[data-multiple="true"] &': {
      borderRadius: 0,
      fontSize: vars.fontSizes.body.s,
    },
    '[data-multiple="true"] &:first-child': {
      borderStartStartRadius: vars.radii.xs,
      borderStartEndRadius: vars.radii.xs,
    },
    '[data-multiple="true"] &:last-child': {
      borderEndStartRadius: vars.radii.xs,
      borderEndEndRadius: vars.radii.xs,
    },
  },
});

export const FDRCellStyles = styleVariants({
  1: [
    FDRCellBaseStyles,
    {
      backgroundColor: vars.colors.difficulties[1].backgroundColor,
      color: vars.colors.difficulties[1].color,
    },
  ],
  2: [
    FDRCellBaseStyles,
    {
      backgroundColor: vars.colors.difficulties[2].backgroundColor,
      color: vars.colors.difficulties[2].color,
    },
  ],
  3: [
    FDRCellBaseStyles,
    {
      backgroundColor: vars.colors.difficulties[3].backgroundColor,
      color: vars.colors.difficulties[3].color,
    },
  ],
  4: [
    FDRCellBaseStyles,
    {
      backgroundColor: vars.colors.difficulties[4].backgroundColor,
      color: vars.colors.difficulties[4].color,
    },
  ],
  5: [
    FDRCellBaseStyles,
    {
      backgroundColor: vars.colors.difficulties[5].backgroundColor,
      color: vars.colors.difficulties[5].color,
    },
  ],
});

export const TeamnameStyles = style({
  fontFamily: vars.fonts.bold,
});
